import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import nl2br from 'react-nl2br';
import {youtubeVideoId} from '../utils';
import YouTube from 'react-youtube';

const useStyles = makeStyles((theme) => ({
  root: {
  },
  image: {
    float: 'right',
    marginLeft: 10,
    marginBottom: 10,
  }
}));

const raw = (html) => {
  return <div dangerouslySetInnerHTML={{__html: html}}></div>;
}

const renderIfPresent = (content, attr, label, rawOutput = false) => {
  if( (content[attr] == null) || (content[attr] == "") ) return <></>;
  return <>
    <Typography color='primary' gutterBottom variant='subtitle1'>{label}</Typography>
    <Typography gutterBottom variant='subtitle1' component='div'>{rawOutput ? nl2br(content[attr]) : content[attr]}</Typography>
</>;
}

const renderImage = (content, attr) => {
  const classes = useStyles();
  if( (content[attr] == null) || (content[attr] == "") || (!content[attr].thumb.url) ) return <></>;
  return <img src={content[attr].thumb.url} alt='' className={classes.image} />;
}

const renderVideo = (content, attr) => {
  if(content[attr]) {
    let videoId = youtubeVideoId(content[attr]);
    if( !videoId ) return <></>;
    const opts = {
      //height: '390',
      width: '100%',
      playerVars: {
        // https://developers.google.com/youtube/player_parameters
        //autoplay: 1,
      },
    };
    return <YouTube videoId={videoId} opts={opts} />;
  }
}

export default function Content(props) {
  let content = props.content;

  return (<div className='ql-editor'>
    <Typography gutterBottom variant='h5'>{content.title}</Typography>
    {renderImage(content, 'image')}
    <Typography gutterBottom variant='body1' component="div" >{raw(content.body)}</Typography>
    {renderVideo(content, 'youtube_url')}
  </div>);
}
